import { render, staticRenderFns } from "./DistributionNetwork.vue?vue&type=template&id=233a5958"
import script from "./DistributionNetwork.vue?vue&type=script&lang=js"
export * from "./DistributionNetwork.vue?vue&type=script&lang=js"
import style0 from "./DistributionNetwork.vue?vue&type=style&index=0&id=233a5958&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports